export default __webpack_public_path__ + "static/media/problema-05.47c2f3ff.webp";